// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2SzM_","name":"Header_name__1Dqbg","birthday":"Header_birthday__1gnbs","skeleton":"Header_skeleton__3Sjgv"};